import BaseEntity from '../BaseEntity.model';

export default interface ICreatedBy extends BaseEntity {
    Name: string;
}

export class CreatedBy implements ICreatedBy {
    Id: string;
    Name: string;

    constructor() {
        this.Id = '';
        this.Name = '';
    }
}